export const WorkplanCurrentStatus = Object.freeze({
    Active: 0,
    Paused: 1,
    Stopped: 2,
    Scheduled: 3,
    Draft: 4
});

export const WorkplanStatus = Object.freeze({
    NotStarted: 0,
    Played: 1
});

export const ShiftLineCurrentStatus = Object.freeze({
    Active: 0,
    Paused: 1,
    Stopped: 2,
    Scheduled: 3,
    Draft: 4
});

export const ShiftLineStatus = Object.freeze({
    NotStarted: 0,
    Active: 1
});

export const StateStatus = Object.freeze({
    Active: 0,
    Paused: 1,
    Stopped: 2,
    NotActive: 3
});

export const SummaryReliefStatus = Object.freeze({
    PausedLine: 0,
    Active: 1,
    Stopped: 2,
    NotActive: 3,
    UnAssign: 4,
    Paused: 5
});